import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=4ce8d958"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"
import style0 from "./Rating.vue?vue&type=style&index=0&id=4ce8d958&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports